export const EVENT_DROPDOWN_SHOW = 'fabric-dropdown-show'
export const EVENT_DROPDOWN_HIDE = 'fabric-dropdown-hide'
export const EVENT_STATIC_DROPDOWN_SHOW = 'fabric-static-dropdown-show'
